export default {

  name: 'Organiser',

  inject: [
    'organiserData'
  ],

  data () {
    return {
      currentOrganiser: null,
      organiserUuid: ''
    };
  },

  methods: {
    checkOrganiserIsInData: function (uuid) {
      if (this.organiserData.organisers.hasOwnProperty(uuid)) {
        this.currentOrganiser = this.organiserData.organisers[uuid];
      } else {
        this.$router.push({ name: 'Events' });
      }
    }
  },

  mounted: function () {
    let proxy = this;
    this.organiserUuid = this.$route.params.uuid;
    if (this.organiserData.organisers instanceof Promise) {
      this.organiserData.organisers.then(function () {
        proxy.checkOrganiserIsInData(proxy.organiserUuid);
      });
    } else {
      this.checkOrganiserIsInData(this.organiserUuid);
    }
  }
};



// WEBPACK FOOTER //
// ./src/apps/booking/components/organiser/Organiser.js